import { Injectable } from '@angular/core';
import { Products } from '../../../shared/model/e-commerce/product.model';
import { CartItem } from '../../../shared/model/e-commerce/cart.model';
import { ProductsService } from './products.service';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subscriber, Observable, map } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AngularFirestore } from '@angular/fire/compat/firestore';


let products = JSON.parse(localStorage.getItem("cartItem")) || [];
@Injectable({
  providedIn: 'root'
})
export class CartService {
  public cartItems: BehaviorSubject<CartItem[]> = new BehaviorSubject([]);
  public observer: Subscriber<{}>;
  private itemsInCart: CartItem[] = [];

  public itemList: Products[];
  constructor(
    private route: ActivatedRoute,
    private productService: ProductsService,
    private toastrService: ToastrService,
    private afs: AngularFirestore
  ) {
    this.cartItems.subscribe(products => products = products);
    this.itemList = [];
  }

  getAll(): Observable<CartItem[]> {
    const itemsList = new Observable(observer => {
      observer.next(products);
      observer.complete();
    });
    return <Observable<CartItem[]>>itemsList;
  }

  public addToCart(product: Products, variant = null) {
    var item: CartItem | boolean = false;
    delete product.variants;
    //producto simple
    if (variant === null) {
      const index = products.findIndex(prod => prod.product.id === product.id)
      //Existe producto simple
      if (index !== -1) {
        const stockAvailable = products[index].product.stock >= products[index].quantity + 1;
        if (stockAvailable) {
          if (products[index].product.isChange) {
            products.push({ quantity: 1, product, variants: [] })
          } else {
            products[index].quantity = products[index].quantity + 1
          }
          localStorage.setItem('cartItem', JSON.stringify(products));
          this.playAudio()
        } else {
          this.toastrService.warning('Máximo de stock alcanzado');
        }
      }
      // No existe producto simple
      else {
        const stockAvailable = product.stock >= 1;
        if (stockAvailable) {
          item = { product, quantity: 1, variants: [] };
          products.push(item);

          localStorage.setItem('cartItem', JSON.stringify(products));
          this.playAudio()
        } else {
          this.toastrService.warning('Máximo de stock alcanzado');
        }
      }
    }
    // Producto variable
    else {
      const index = products.findIndex(prod => prod.product.id === product.id)
      //Existe producto variable
      if (index !== -1) {
        const indexVariant = products[index].variants.findIndex(vari => vari.variantName.toLowerCase() === variant.variantName.toLowerCase())

        //Existe variante
        if (indexVariant !== -1) {
          //StockDisponible
          const stockAvailable = products[index].variants[indexVariant].stock >= products[index].variants[indexVariant].quantity + 1
          if (stockAvailable) {
            products[index].variants[indexVariant].quantity = products[index].variants[indexVariant].quantity + 1;
            localStorage.setItem('cartItem', JSON.stringify(products));
            this.playAudio()
          } else {
            this.toastrService.warning('Producto sin stock disponible');
          }
        }
        //Variante no existe
        else {

          const stockAvailable = variant.stock >= 1;
          if (stockAvailable) {
            products[index].variants.push({ ...variant, quantity: 1 })
            localStorage.setItem('cartItem', JSON.stringify(products));
            this.playAudio()
          } else {
            this.toastrService.warning('Producto sin stock disponible');
          }
        }
      } else {
        const stockAvailable = variant.stock >= 1;
        if (stockAvailable) {
          variant.quantity = 1;
          item = { product, quantity: 0, variants: [variant] }
          products.push(item)
          localStorage.setItem('cartItem', JSON.stringify(products));
          this.playAudio()
        }
      }
    }
  }

  public calculateStockCounts(product: CartItem, quantity): CartItem | Boolean {
    let qty = product.quantity + quantity;
    let stock = product.product.stock;
    if (stock < qty) {
      this.toastrService.error('No hay stock disponible. Actualmente ' + stock + ' en stock.');
      return false
    }
    return true
  }

  public removeCartItem(item: CartItem) {
    if (item === undefined) return false;
    const index = products.indexOf(item);
    products.splice(index, 1);
    localStorage.setItem('cartItem', JSON.stringify(products));
  }

  public updateCartQuantity(product: Products, quantity: number): CartItem | boolean {
    return products.find((items, index) => {
      if (items.product.id == product.id) {
        let qty = products[index].quantity + quantity;
        let stock = this.calculateStockCounts(products[index], quantity);
        if (qty != 0 && stock)
          products[index]['quantity'] = qty;
        localStorage.setItem("cartItem", JSON.stringify(products));
        return true;
      }
    });
  }
  public getTotalAmount(): Observable<number> {
    return this.cartItems.pipe(map((product: CartItem[]) => {
      return products.reduce((prev, curr: CartItem) => {
        return prev + curr.variants?.length > 0 ? curr.variants[0].price : curr.product.price * curr.quantity;
      }, 0);
    })
    )
  }
  public getTotalIVA(): Observable<number> {
    return this.cartItems.pipe(map((product: CartItem[]) => {
      return products.reduce((prev, curr: CartItem) => {
        return prev + curr.product.price * curr.quantity;
      }, 0);
    })
    )
  }
  playAudio() {
    let audio = new Audio();
    audio.src = "../../../assets/sounds/codebar.mp3";
    audio.load();
    audio.play();
  }
  getVariantsQuantity(variants) {
    let total = 0;
    variants.map((variant) => {
      total = total + variant.quantity;
    })
    return total;
  }

  getVariantsTotal(variants) {
    let total = 0;
    variants.map((variant) => {
      total = total + (variant.price * variant.quantity);
    })
    return total;
  }

  removeVariant(i, index) {
    if (products[i].variants.length === 1) {
      products.splice(i, 1);
    } else {
      products[i].variants.splice(index, 1);
    }
    localStorage.setItem('cartItem', JSON.stringify(products));
  }

  addDiscountVariant(iProd, iVar = null, discount, type) {
    const price = products[iProd].variants[iVar].price;
    const qty = products[iProd].variants[iVar].quantity;
    products[iProd].variants[iVar].discountType = type;
    if (type === 'percent') {
      products[iProd].variants[iVar].discountTotal = Math.round((price * qty) * Math.round(parseFloat(discount)) / 100);
      products[iProd].variants[iVar].discount = Math.round(parseFloat(discount))
    } else {
      products[iProd].variants[iVar].discountTotal = Math.round(parseFloat(discount))
      products[iProd].variants[iVar].discount = Math.round(parseFloat(discount))
    }
    localStorage.setItem('cartItem', JSON.stringify(products));
  }

  addDiscount(iProd, discount, type) {
    const price = products[iProd].product.price;
    const qty = products[iProd].quantity;
    products[iProd].product.discountType = type;
    if (type === 'percent') {
      products[iProd].product.discountTotal = Math.round((price * qty) * Math.round(parseFloat(discount)) / 100);
      products[iProd].product.discount = Math.round(parseFloat(discount))
    } else {
      products[iProd].product.discountTotal = Math.round(discount)
      products[iProd].product.discount = Math.round(discount)
    }
    localStorage.setItem('cartItem', JSON.stringify(products));
  }

  clearCart() {
    products = [];
    localStorage.removeItem('cartItem');
  }

  decrementVariant(item, v) {
    const ind = products.findIndex(p => p.product.id === item.id);
    const indV = products[ind].variants.findIndex(vi => vi.variantName === v.variantName);
    const qty = products[ind].variants[indV].quantity;
    if (qty === 1) {
      products[ind].variants.splice(indV, 1);
      if (products[ind].variants.length === 0) {
        products.splice(ind, 1)
      }
    } else {
      products[ind].variants[indV].quantity = qty - 1;
    }
    localStorage.setItem('cartItem', JSON.stringify(products));
  }
}
